import clsx from 'clsx';
import styles from './Text.module.scss';

export default function TextComponent({ tag = 'p', size, weight, transform, margin, children }) {
    const Tag = tag;

    const classNames = clsx(
        size && styles[`redl-text-${size}`],
        weight && styles[`redl-text-${weight}`],
        transform && styles[`redl-text-${transform}`],
        margin && styles[`redl-text-margin-${margin}`]
    );

    return <Tag className={classNames}>{children}</Tag>;
}
